import { RouteComponentProps } from "react-router-dom";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { WSPage } from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../query/WSQuery";
import { usePayerQuery } from "../../../../query/payers/queries/usePayerQuery";
import { useRequirementQuery } from "../../../../query/requirements/queries/useRequirementQuery";

export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payerId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payerId }
  }
}) => {
  const queryPayer = usePayerQuery(payerId);
  const queryRequirement = useRequirementQuery(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayer,
          queryRequirement
        }}
      >
        {({ queryPayerData, queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payer={queryPayerData}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
